var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcVisaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "13px",
    viewBox: "0 0 39 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkout-5-(desktop)",
    transform: "translate(-1204.000000, -1164.000000)",
    fill: "#00205B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "order-sumary-right-copy",
    transform: "translate(1196.000000, 1093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "70x50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5682609,26.2042054 L14.2561085,26.2042054 L11.7723979,16.6622153 C11.6545104,16.2232837 11.4042015,15.8352428 11.0360051,15.6523546 C10.1171291,15.1927488 9.1045891,14.8269725 8,14.642494 L8,14.2751274 L13.3356175,14.2751274 C14.0720103,14.2751274 14.6243048,14.8269725 14.7163539,15.4678762 L16.0050412,22.3508317 L19.3155787,14.2751274 L22.535682,14.2751274 L17.5682609,26.2042054 Z M24.3766639,26.2042054 L21.2486096,26.2042054 L23.8243693,14.2751274 L26.9524236,14.2751274 L24.3766639,26.2042054 Z M30.9993538,17.5798366 C31.0914029,16.9373426 31.6436974,16.569976 32.2880411,16.569976 C33.3005811,16.4777368 34.4035553,16.6622153 35.3240462,17.1202308 L35.8763408,14.5518451 C34.9558499,14.1844785 33.9433098,14 33.0244338,14 C29.9884287,14 27.7792505,15.6523546 27.7792505,17.9456129 C27.7792505,19.6902068 29.344085,20.6062379 30.4486741,21.158083 C31.6436974,21.7083377 32.1039429,22.0757044 32.0118938,22.6259591 C32.0118938,23.4513413 31.0914029,23.8187079 30.1725269,23.8187079 C29.0679378,23.8187079 27.9633487,23.5435805 26.9524236,23.0839746 L26.400129,25.6539507 C27.5047181,26.1119662 28.6997414,26.2964447 29.8043305,26.2964447 C33.208532,26.3870936 35.3240462,24.7363293 35.3240462,22.2585925 C35.3240462,19.1383617 30.9993538,18.9554736 30.9993538,17.5798366 L30.9993538,17.5798366 Z M46.2714286,26.2042054 L43.787718,14.2751274 L41.1199092,14.2751274 C40.5676147,14.2751274 40.0153201,14.642494 39.8312219,15.1927488 L35.2319971,26.2042054 L38.4521005,26.2042054 L39.0948292,24.4612019 L43.0513253,24.4612019 L43.4195216,26.2042054 L46.2714286,26.2042054 Z M41.5801547,17.4875974 L42.4990307,21.9834651 L39.923271,21.9834651 L41.5801547,17.4875974 Z",
    id: "visa-logo"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcVisaLogo);
export default __webpack_public_path__ + "static/media/cc-visa-logo.9de5ed976961133ab058d183b905b998.svg";
export { ForwardRef as ReactComponent };